import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/js/rem?v1'
import './assets/css/reset.css'
import Vant from 'vant';
import 'vant/lib/index.css';
// 引入阿里巴巴图标矢量库
import './assets/iconfont/iconfont.css'


Vue.prototype.$bus=new Vue()

Vue.use(Vant);
Vue.config.productionTip = false

let vue =new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

export default  vue
